import router from '@/router'

//白名单
const whiteList = ['/login', '/video']

// 页面加载之前
router.beforeEach(async (to, from, next) => {
  if (to.hash) {
    // 等待页面刷新后设置hash
    // Vue.nextTick(() => {
    //   const hash = to.hash
    //   if (hash) {
    //     window.location.hash = hash
    //   }
    // })
  }
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - ${process.env.VUE_APP_DOCUMENT_TITLE}`
  } else {
    document.title = process.env.VUE_APP_DOCUMENT_TITLE
  }
  const getToken = getQueryVariable('token')
  if (getToken) {
    localStorage.setItem('token', getToken)
  }
  const hasToken = localStorage.getItem('token')
  // 白名单中路由直接放行
  if (whiteList.includes(to.path)) {
    next()
  } else {
    // 有token直接放行，无token则跳到登陆
    if (hasToken) {
      next()
    } else {
      next(`/login`)
    }
  }
})

// 页面加载之后
router.afterEach(async (to, from, next) => {})

// 获取url中的参数
function getQueryVariable(variable) {
  if (window.location.href.indexOf(variable) > 0) {
    var query = window.location.href.split('?')[1]
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] === variable) {
        return pair[1]
      }
    }
    return false
  }
}
